/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * Nahrazovač obsahových úloh
 */
class ContentTaskReplacer {
  /**
   * @param {Store} primaryStore
   * @param {TaskToContentTaskConverter} taskConverter
   */
  constructor(primaryStore, taskConverter) {
    this.primaryStore = primaryStore;
    this.taskConverter = taskConverter;
  }

  /**
   * Nahradí obsahové úlohy v perzistentním úložišti za nové.
   * @param {ContentInfo} contentInfo Obsah s novými úlohami
   * @returns {Promise.<Array.<ContentTask>>}
   */
  replace(contentInfo) {
    // TODO DRY ReplacerCommon#replace
    return new Promise((resolve) =>
      resolve(
        this.primaryStore.replaceAsync(
          'contentTask',
          JSON.parse(JSON.stringify(contentInfo.contentTasks)),
          null,
          { onConflict: 'replace' }
        )
      )
    );
  }

  /**
   * Obnoví obsahové úlohy z perzistentího úložiště.
   * @param {Array.<Task>} tasks Obnovené staré úlohy pro případ,
   * že bude nutná migrace ze starého fromátu na nový.
   * @returns {Promise.<Array.<ContentTask>>}
   */
  restore(tasks) {
    return new Promise((resolve) =>
      resolve(
        // Načtou se všechny obsahové úlohy z perzistentního úložiště.
        this.primaryStore.findAll('contentTask').then((contentTasks) => {
          // Pokud se podařilo nějaké úlohy načíst, použijí se.
          if (contentTasks.length) {
            return contentTasks;
          }
          // Bez dostupných obsahových úloh se provede pokus o migraci dat
          // ze starého formátu úloh.
          return tasks.reduce((acc, task) => {
            // Migrace úloh ze statého do nového formátu.
            const contentTask = this.taskConverter.convert(
              this.primaryStore,
              task
            );
            // Ne všechny úlohy jdou převést, použijí se pouze ty, které lze.
            if (!isNil(contentTask)) {
              acc.push(contentTask);
            }
            return acc;
          }, []);
        })
      )
    );
  }
}

export default ContentTaskReplacer;
